import { render } from "./Range.vue?vue&type=template&id=1b303203&scoped=true"
import script from "./Range.vue?vue&type=script&setup=true&lang=js"
export * from "./Range.vue?vue&type=script&setup=true&lang=js"

import "./Range.vue?vue&type=style&index=0&id=1b303203&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b303203"],['__file',"src/components/Paragraphs/Range.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b303203"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b303203', __exports__)) {
    api.reload('1b303203', __exports__)
  }
  
  module.hot.accept("./Range.vue?vue&type=template&id=1b303203&scoped=true", () => {
    api.rerender('1b303203', render)
  })

}


export default __exports__